import { ElementType } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

const HIGHLIGHT_PATTERN = /\*\*(.*?)\*\*/g;
const STRAY_DELIMITER_PATTERN = /\*\*/g;

export const HighlightedText = ({
	text,
	sx,
	component = 'strong',
}: {
	text?: string;
	sx?: SxProps<Theme>;
	component?: ElementType;
}) => {
	if (!text) {
		return null;
	}

	return (
		<>
			{text.split(HIGHLIGHT_PATTERN).map((segment, index) =>
				index % 2 === 1 ? (
					segment ? (
						<Box component={component} key={`highlight_${index}`} sx={sx}>
							{segment}
						</Box>
					) : null
				) : (
					segment.replace(STRAY_DELIMITER_PATTERN, '')
				)
			)}
		</>
	);
};
